<template>
  <div class="contain mx-auto my-32 flex flex-col items-center justify-center">
    <div class="flex">
      <button
        @click="showListTab"
        class="focus:bg-buttoncolor text-black focus:outline-none font-medium rounded-l-lg p-5 bg-btnGray focus:text-white shadow-lg md:w-48"
      >
        List View
      </button>
      <button
        @click="showMapTab"
        class="focus:bg-buttoncolor focus:text-white text-black rounded-r-lg focus:outline-none font-medium bg-btnGray p-5 shadow-lg md:w-48"
      >
        Map View
      </button>
    </div>
    <div
      v-show="displayListTab === true"
      v-for="(view, i) in listView"
      :key="i"
      class="flex flex-col md:flex-row items-center rounded-lg shadow-xl w-8/12 sm:h-64 md:h-56 px-4 md:px-12 py-6 md:py-10 mt-10"
    >
      <router-link to="/nav/a">
        <img
          class="w-16 h-16 md:w-32 md:h-32"
          :src="require(`@/assets/images/${view.img}`)"
          alt=""
        />
      </router-link>
      <div
        class="text-lightPurple text-sm font-semibold mt-5 md:mt-0 ml-3 md:ml-8 lg:ml-20"
      >
        <router-link to="/streams/a">
          <div class="text-black uppercase text-base text-center md:text-left">
            {{ view.name }}
          </div>
        </router-link>
        <div class="my-3">Balloon ID: {{ view.id }}</div>
        <div class="uppercase">Site location name: {{ view.location }}</div>
      </div>
    </div>

    <div v-show="displayMapTab === true" class="mt-10 w-full px-2">
      <GoogleMap />
    </div>
  </div>
</template>

<script>
import GoogleMap from "@/components/map/Map.vue";

export default {
  components: { GoogleMap },
  data() {
    return {
      displayListTab: null,
      displayMapTab: null,
      listView: [
        {
          img: "balloon.svg",
          name: "Balloon A",
          id: " ASNQ11-2DB4-6713",
          location: "Ife"
        }
      ]
    };
  },
  mounted() {
    this.displayListTab = !this.displayListTab;
  },
  methods: {
    showListTab() {
      this.displayListTab = true;
      this.displayMapTab = false;
    },
    showMapTab() {
      this.displayMapTab = true;
      this.displayListTab = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
